import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F5F5FC",
  d: "M12 0c-.947 0-1.714.768-1.714 1.714v3.429h3.428V1.714C13.714.768 12.947 0 12 0M36 0c-.947 0-1.714.768-1.714 1.714v3.429h3.428V1.714C37.714.768 36.947 0 36 0M42.857 5.143h-5.143V12a1.714 1.714 0 1 1-3.428 0V5.143H13.714V12a1.714 1.714 0 1 1-3.428 0V5.143H5.143A5.143 5.143 0 0 0 0 10.286v32.571A5.143 5.143 0 0 0 5.143 48h37.714A5.143 5.143 0 0 0 48 42.857V10.286a5.143 5.143 0 0 0-5.143-5.143m1.714 37.714c0 .947-.767 1.714-1.714 1.714H5.143a1.714 1.714 0 0 1-1.714-1.714V20.571H44.57z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F5F5FC",
  d: "M13.714 24h-3.428a1.714 1.714 0 1 0 0 3.428h3.428a1.714 1.714 0 1 0 0-3.428M25.714 24h-3.428a1.714 1.714 0 1 0 0 3.428h3.428a1.714 1.714 0 1 0 0-3.428M37.714 24h-3.428a1.714 1.714 0 1 0 0 3.428h3.428a1.714 1.714 0 1 0 0-3.428M13.714 30.857h-3.428a1.714 1.714 0 1 0 0 3.429h3.428a1.714 1.714 0 1 0 0-3.429M25.714 30.857h-3.428a1.714 1.714 0 1 0 0 3.429h3.428a1.714 1.714 0 1 0 0-3.429M37.714 30.857h-3.428a1.714 1.714 0 1 0 0 3.429h3.428a1.714 1.714 0 1 0 0-3.429M13.714 37.714h-3.428a1.714 1.714 0 1 0 0 3.429h3.428a1.714 1.714 0 1 0 0-3.429M25.714 37.714h-3.428a1.714 1.714 0 1 0 0 3.429h3.428a1.714 1.714 0 1 0 0-3.429M37.714 37.714h-3.428a1.714 1.714 0 1 0 0 3.429h3.428a1.714 1.714 0 1 0 0-3.429"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }